import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './auth';
import { App } from './App';
import { registerServiceWorker } from './pwa';
import { ToastProvider } from './toast';
import './styles.css';

registerServiceWorker();

// Apply the saved theme before the first paint so loading placeholders match it.
document.documentElement.dataset.theme =
  (localStorage.getItem('booth-control-centre-theme') ??
    localStorage.getItem('ai-booth-theme')) === 'dark'
    ? 'dark'
    : 'light';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ToastProvider>
  </StrictMode>,
);
